import { EventTypes } from '@candulabs/craft';
import { useCallback, useEffect, useRef } from 'react';
import { useDispatch } from 'react-redux';

import { CRAFT_ROOT_ID } from 'craft/constants';
import { useEditor } from 'craft/hooks';
import { setViewportContainerDom, setViewportContentDom } from 'craft/state';

export const useCraftViewportEventHandlers = () => {
  const containerRef = useRef<HTMLElement | null>(null);
  const contentRef = useRef<HTMLElement | null>(null);
  const dispatch = useDispatch();

  const {
    query,
    connectors: { select, hover },
  } = useEditor();

  const focusedElements = query.getEvent(EventTypes.focused).all();
  const focus = focusedElements.length > 0;

  const disableDrag = useCallback((e) => {
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();
  }, []);

  // Disable Drag  when there is focus
  useEffect(() => {
    // TODO: we should be able to use Craft to disable drag events
    // but right now, that causes an issue with Slate

    const { current: dom } = containerRef;

    if (!dom) {
      return;
    }

    if (focus) {
      dom.addEventListener('dragstart', disableDrag, true);
    } else {
      dom.removeEventListener('dragstart', disableDrag, true);
    }

    // eslint-disable-next-line consistent-return
    return () => {
      dom.removeEventListener('dragstart', disableDrag, true);
    };
  }, [focus]);

  useEffect(() => {
    const { current: dom } = containerRef;

    if (!dom) {
      return;
    }

    select(dom, CRAFT_ROOT_ID);
    hover(dom, CRAFT_ROOT_ID);

    // save viewport container ref to the store
    dispatch(setViewportContainerDom(containerRef));
    // save viewport content ref to the store
    dispatch(setViewportContentDom(contentRef));
  }, []);

  return {
    containerRef,
    contentRef,
  };
};
